
import React, { useState } from 'react';
import Modal from 'react-modal';

const DeleteOrgUserModal = ({isOpen, onRequestClose, onConfirm}) => {

    const closeDeleteOrgUserModal = () => {
        onRequestClose();
    };

    const handleConfirm = () => {
        // Call the onConfirm function passed as a prop
        onConfirm();
        // Close the modal
        closeDeleteOrgUserModal();
    };

    return (
    
                <form>
                    <div className='d-flex flex-column justify-content-center align-items-center text-center'>
                        <img src="/images/invite-sent.svg" alt="revoke-user"></img>
                        <h3 className='font-weight-600 font-20 my-4'>Delete Admin</h3>
                        <p>Are you sure you want to delete Admin?<br /> This action cannot be undone</p>
                        <div className='d-flex justify-content-between align-items-center w-100 mt-3'>
                            <button onClick={closeDeleteOrgUserModal} className='btn btn-md w-100 btn-secondary me-3'>Cancel</button>
                            <button onClick={handleConfirm} className='btn btn-md w-100 btn-primary'>Confirm</button>
                        </div>
                    </div>
                </form>

    )

}

export default DeleteOrgUserModal;